import { createActionTypes } from 'utils/action/actionTypes';

export const FETCH_CHARGER_BOOKING = createActionTypes('FETCH_CHARGER_BOOKING');
export const DELETE_CHARGER_BOOKING = createActionTypes('DELETE_CHARGER_BOOKING');
export const START_REMOTE = createActionTypes('START_REMOTE');
export const STOP_TRANSACTION = createActionTypes('STOP_TRANSACTION');
export const GET_CHARGER_BOOKING = createActionTypes('GET_CHARGER_BOOKING');
